import React, { useState, useEffect,useRef } from "react";
import axios from "axios";
import {isNull,SetEmptyInputFile} from "../../../components/common/Common";
/* css */
import "../../../css/admin_layout.css";
import "../../../css/admin.css";
import cancelIcon from "../../../img/icon/icon-cancel.svg";

const ChildrenLevelDetail = ({varShowDetail,setShowDetail,varChildrenLevelIndex,GetChildrenLevelList}) => {
  const filekrRef = useRef(null);
  const fileenRef = useRef(null);
  //원생등급정보
  const [varChildrenLevelInfo,setChildrenLevelInfo] = useState({});
  const [varCerificationPhoto,setCerificationPhoto] = useState({});

  //원생등급정보 읽어오기
  const GetChildrenLevelInformation = async () => {
    const sendData = {mode:2,vidx:varChildrenLevelIndex};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_variable_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        if(datas.results?.length > 0){
          let dataInfo = datas.results[0];
          setChildrenLevelInfo(dataInfo);
          let image1 = null;
          if(dataInfo.vl_image===1 && !isNull(dataInfo.vl_file)) image1 = `${process.env.REACT_APP_HOST}/certificate/${dataInfo.vl_file}`;
          let image2 = null;
          if(dataInfo.vl_eimage===1 && !isNull(dataInfo.vl_efile)) image2 = `${process.env.REACT_APP_HOST}/certificate/${dataInfo.vl_efile}`;
          setCerificationPhoto({vl_file:image1,vl_efile:image2});
        }
      }
    });
  }

  //페이지 정보 표시 - 최초
  useEffect(() => {
    //원생등급 정보
    if(varChildrenLevelIndex === 0){
      const variableState = {vl_idx:0,vl_name:"",vl_rdate:"",vl_status:1};
      setChildrenLevelInfo(variableState);
      setCerificationPhoto({vl_file:null,vl_efile:null});
    } else {
      GetChildrenLevelInformation();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varChildrenLevelIndex]);

  //정보입력
  const onChangeInputHandler = (e) => {
    const { name, value } = e.currentTarget;
    if(name === "vl_name") setChildrenLevelInfo({...varChildrenLevelInfo,[name]:value});
    else setChildrenLevelInfo({...varChildrenLevelInfo,[name]:Number(value)});
  }

  //원생등급 저장 - 사진 저장
  const onUpdateChildrenLevelHandler = async (e) => {
    if(varChildrenLevelInfo.vl_name === "") {
      alert('등급명을 먼저 입력하세요.'); return false;
    } else if(varChildrenLevelInfo.vl_terms === 0) {
      alert('기간(년)을 먼저 입력하세요.'); return false;
    } else if(varChildrenLevelInfo.vl_studys === 0) {
      alert('출석횟수를 먼저 입력하세요.'); return false;
    }

    if(!window.confirm('변수명을 저장합니까?')) return false;

    if(isNull(varCerificationPhoto.vl_file) && isNull(varCerificationPhoto.vl_efile)) {
      UpdateChildrenLevel([]);
    } else {
      let imode = 0;
      let formData = new FormData();
      if(!isNull(varCerificationPhoto.vl_file)){
        imode = 1;
        formData.append('certificate',filekrRef.current.files[0]);
      } 
      if(!isNull(varCerificationPhoto.vl_efile)){
        imode += 2;
        formData.append('certificate',fileenRef.current.files[0]);
      } 
      await axios.post(`${process.env.REACT_APP_HOST}/certificateArray`, formData).then((res) => {
        console.log(res.data);
        if(res.data.retvalue === 1) {
          UpdateChildrenLevel(imode,res.data.fileNames);
        }
      });
    }
  }

  //원생등급 저장
  const UpdateChildrenLevel = async(imode,fileNames) => {
    const sendData = {mode:imode,vl_idx:varChildrenLevelIndex,dataInfo:varChildrenLevelInfo,fileNames:fileNames};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_update_level_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      alert(datas.message);
      if(datas.retvalue === 1) {
        setShowDetail(false);
        GetChildrenLevelList();
      }
    });
  }

  //사진 선택후 화면에서 표시
  const onChangeAttachFileHandler = (e,ino) => {
    let uploadFile = null;
    let fieldName1 = "";
    let fieldName2 = "";
    if(ino === 1){
      uploadFile = filekrRef.current.files[0];
      fieldName1 = "vl_file";
      fieldName2 = "vl_image";
    } else {
      uploadFile = fileenRef.current.files[0];
      fieldName1 = "vl_efile";
      fieldName2 = "vl_eimage";
    }
    console.log(uploadFile);
    const previewFile = URL.createObjectURL(uploadFile);
    setCerificationPhoto({...varCerificationPhoto,[fieldName1]:previewFile});
    setChildrenLevelInfo({...varChildrenLevelInfo, [fieldName2]:1});
  }

  //이미지 선택시
  const onSelectPhotoHandler = (e,ino) => {
    if(ino === 1) filekrRef.current.click();
    else fileenRef.current.click();
  }
  
  //사진삭제
  const onDeleteAttachFileHandler = async(e,ino) => {
    let fileBox = null;
    let fieldName1 = "";
    let fieldName2 = "";
    if(ino === 1){
      fileBox = filekrRef.current;
      fieldName1 = "vl_file";
      fieldName2 = "vl_image";
    } else {
      fileBox = fileenRef.current;
      fieldName1 = "vl_efile";
      fieldName2 = "vl_eimage";
    }

    if(isNull(varChildrenLevelInfo[fieldName1])) {
      SetEmptyInputFile(fileBox);
      setChildrenLevelInfo({...varChildrenLevelInfo, [fieldName2]:0});
      setCerificationPhoto({...varCerificationPhoto,[fieldName1]:null});
    } else {
      if(!window.confirm("첨부된 파일을 삭제하시겠습니까?")) return false;
      const sendData = {mode:ino,vl_idx:varChildrenLevelInfo.vl_idx};
      console.log(sendData);
      await axios.post(`${process.env.REACT_APP_HOST}/_delete_children_level_image`,sendData).then((res) => {
        const datas = res.data;
        console.log(datas);
        if(datas.retvalue === 1) {
          setChildrenLevelInfo({...varChildrenLevelInfo, [fieldName1]:null,[fieldName2]:0});
          setCerificationPhoto({...varCerificationPhoto,[fieldName1]:null});
        } else {
          alert(datas.message);
        }
      });
    }
  }

  return (
    <div className="admin-content"style={varShowDetail?{display:""}:{display:"none"}}>
      <div className="main-box">
        <table cellPadding="5" cellSpacing="0" border="1" className="write">
          <colgroup><col width="20%"/><col width="30%"/><col width="20%"/><col width="30%"/></colgroup>
          <thead></thead>
          <tbody>
            <tr>
              <th>등급명</th>
              <td colSpan={3}><input type="text" className="w_s_input" name="vl_name" value={varChildrenLevelInfo.vl_name||""} onChange={(e)=>onChangeInputHandler(e)}/></td>
            </tr>
            <tr>
              <th>기간(년)</th>
              <td colSpan={3}><input type="text" className="w_s_input" name="vl_terms" value={varChildrenLevelInfo.vl_terms||""} onChange={(e)=>onChangeInputHandler(e)}/></td>
            </tr>
            <tr>
              <th>출석횟수</th>
              <td colSpan={3}><input type="text" className="w_s_input" name="vl_studys" value={varChildrenLevelInfo.vl_studys||""} onChange={(e)=>onChangeInputHandler(e)}/></td>
            </tr>
            <tr>
              <th>수료증 이미지(국문)&nbsp;
                <input type="file" ref={filekrRef} name="file" style={{width:"90px",border:"none",backgroundColor:"transparent"}} onChange={e=>onChangeAttachFileHandler(e,1)} />
              </th>
              <td>
                {varChildrenLevelInfo.vl_image===0 || isNull(varCerificationPhoto.vl_file)?null:
                  <div className={`file-box`} style={{position:"relative"}}>
                    <img src={varCerificationPhoto.vl_file} alt="" style={{cursor:"pointer",height:"180px"}} onClick={e=>onSelectPhotoHandler(e,1)}/>
                    <img src={cancelIcon} alt="" style={{position:"absolute",top:"5px",right:"5px"}} onClick={e=>onDeleteAttachFileHandler(e,1)} />
                  </div>
                }
              </td>
              {varChildrenLevelInfo.vl_idx === 1?
                <td colSpan={2}></td>
              :
                <>
                  <th>수료증 이미지(영문)&nbsp;
                    <input type="file" ref={fileenRef} name="file" style={{width:"90px",border:"none",backgroundColor:"transparent"}} onChange={e=>onChangeAttachFileHandler(e,2)} />
                  </th>
                  <td>
                    {varChildrenLevelInfo.vl_eimage===0 || isNull(varCerificationPhoto.vl_efile)?null:
                      <div className={`file-box`} style={{position:"relative"}}>
                        <img src={varCerificationPhoto.vl_efile} alt="" style={{cursor:"pointer",height:"180px"}} onClick={e=>onSelectPhotoHandler(e,2)}/>
                        <img src={cancelIcon} alt="" style={{position:"absolute",top:"5px",right:"5px"}} onClick={e=>onDeleteAttachFileHandler(e,2)} />
                      </div>
                    }
                  </td>
                </>
              }
            </tr>
          </tbody>
        </table>
      </div>
      <div className="btn-center" style={{marginBottom:"20px"}}>
        <button onClick={(e)=>onUpdateChildrenLevelHandler(e)} style={{width:"90px"}} className="btn">저장</button>
        <button onClick={()=>setShowDetail(false)} style={{width:"90px"}} className="btn line">닫기</button>
      </div>
    </div>
  );
}
export default ChildrenLevelDetail;